import { render, staticRenderFns } from "./ShopPurchaseMethodSelectModal.vue?vue&type=template&id=dd1e37d0&scoped=true&"
import script from "./ShopPurchaseMethodSelectModal.vue?vue&type=script&lang=js&"
export * from "./ShopPurchaseMethodSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopPurchaseMethodSelectModal.vue?vue&type=style&index=0&id=dd1e37d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1e37d0",
  null
  
)

export default component.exports